import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-study-one',
  templateUrl: './case-study-one.component.html',
  styleUrls: ['./case-study-one.component.scss']
})
export class CaseStudyOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
